import { PortfolioEnergyChart } from "."
import { OverviewPanelWrapper } from "../../../components/OverviewPanelWrapper";
import { FormattedMessage } from "react-intl";
import { IoWaterOutline } from "react-icons/io5";
import { filterCounters, getColor, getDisplayMode, getUnitFromDisplayMode, startEndDateFromTimeRange } from "./utils";
import { TimeRange } from "./types";
import { themedUseStyletron } from "../../../../theme/customTheme";
import { CounterMedium } from "../../../Devices/CounterMedium";
import { SlEnergy, SlFire } from "react-icons/sl";
import { BsSnow } from "react-icons/bs";
import { DisplayMode } from "../../../../hooks/useGetBuildingsEnergy";

const OverviewPanel = (props: any) => {
    const [css, theme] = themedUseStyletron();
    const { start, end } = startEndDateFromTimeRange(props.timeRange);

    const counterMediumFilter = props.counterMediumFilter;
    const color = getColor(counterMediumFilter, theme);
    const displayMode = getDisplayMode(counterMediumFilter);

    const convertToMWh = displayMode === DisplayMode.KWH && !props.byM2;
    const valueFactor = convertToMWh ? 0.001 : 1;
    const dimension = convertToMWh ? "MWh" : getUnitFromDisplayMode(displayMode);
    return (
        <OverviewPanelWrapper {...props}
            description={<FormattedMessage id={`CounterMedium.${CounterMedium[counterMediumFilter]}`} defaultMessage={`${CounterMedium[counterMediumFilter]}`} />}
            icon={<Icon medium={counterMediumFilter}></Icon>} name={<Name displayMode={displayMode} {...props} start={start} end={end}></Name>}>
            <PortfolioEnergyChart valueFactor={valueFactor} dimension={dimension} medium={counterMediumFilter} filterCounters={(v) => filterCounters(v, counterMediumFilter)} colors={[color]} color={theme.colors.primary} byM2={props.byM2} start={start} end={end} take={props.numItems} displayMode={displayMode} ></PortfolioEnergyChart>
        </OverviewPanelWrapper>
    )
}

export default OverviewPanel;


export const Name = (props: any) => {

    const displayMode = getDisplayMode(props.counterMediumFilter);

    const convertToMWh = props.displayMode === DisplayMode.KWH && !props.byM2;
    const displayUnitString = convertToMWh ? "MWh" : getUnitFromDisplayMode(displayMode);

    return (
        <>
            <> {!props.hideNumItems && <>Top {props.numItems} |</>} <FormattedMessage id={TimeRange[props.timeRange]} defaultMessage={TimeRange[props.timeRange]} /> | {displayUnitString}
            </>
            {props.byM2 && '/m²'}
        </>
    )
}

const Icon = (props: { medium: CounterMedium }) => {
    const { medium } = props;
    const [css, theme] = themedUseStyletron();
    if (medium === undefined)
        return <SlEnergy size='100%' color={theme.colors.backgroundPrimary}></SlEnergy>

    if (medium === CounterMedium.ElectricityMeter)
        return <SlEnergy size='100%' color={theme.colors.backgroundPrimary}></SlEnergy>
    if (medium === CounterMedium.ColdMeter)
        return <BsSnow size='100%' color={theme.colors.backgroundPrimary}></BsSnow>
    if (medium === CounterMedium.WaterMeter)
        return <IoWaterOutline size='100%' color={theme.colors.backgroundPrimary}></IoWaterOutline>
    if (medium === CounterMedium.HeatMeter)
        return <SlFire size='100%' color={theme.colors.backgroundPrimary}></SlFire>

    return <SlEnergy color={theme.colors.backgroundPrimary} size={'100%'}></SlEnergy>;
}